import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import LinkUI from '@material-ui/core/Link';
import DPP from "./DPP.pdf"; // adjust path as needed
import DPP2 from "./DPP2.pdf"; // adjust path as needed
import DPP3 from "./DPP3.pdf"; // adjust path as needed
import DPP4 from "./DPP4.pdf"; // adjust path as needed
import SlidesLecture1 from "./SlidesLecture1.pdf"; // adjust path as needed
import SlidesLecture2 from "./SlidesLecture2.pdf"; // adjust path as needed







const useStyles = makeStyles({
  root: {
    marginTop: 30,
    width: '100%',
    padding: '3%',
    margin: 'auto',
    fontSize: '16',
    minWidth: 600,
  },
  p: {
    color: '#333333',
    paddingTop: 0,
    marginTop: 12,
    fontSize: 16
  },
  h4: {
    paddingLeft: 0,
    textAlign: 'left',
    color: '#009688',
    //color: '#6a737b',
    marginTop: 0,
    marginBottom: 20,
    marginLeft: 0
  }

});



function Contact() {

  const classes = useStyles();



  return (
   <div>
  <Grid
    container
    spacing={2}
    style={{
      marginTop: 70,
      marginBottom: -20,
      padding: '5%',
      paddingTop: 0,
      backgroundColor: '#E6EBE9',
    }}
  >
    {/* Header */}
    <Grid
      item
      xs={12}
      style={{
        minWidth: 200,
        borderLeft: '0.03em solid grey',
        paddingLeft: '3%',
        paddingTop: 0,
      }}
    >
    <Typography variant="h3" className={classes.h4}>
  The Aztec Diamond
</Typography>
<Typography variant="h4" className={classes.h4}>
  From combinatorics to analysis in random tilings
</Typography>
</Grid>

{/* Main content */}
<Grid
  item
  xs={12}
  style={{
    minWidth: 200,
    paddingLeft: '3%',
    paddingTop: 0,
  }}
>
  <Typography
    variant="h6"
    style={{ marginTop: 15, color: '#009688', fontStyle: 'italic' }}
  >
    Description
  </Typography>

  <Typography className={classes.p}>
    Random tilings form a meeting point between combinatorics, probability,
    analysis, and mathematical physics. At the most elementary level, they ask
    a simple counting question: in how many ways can a planar region be tiled by
    elementary pieces? Yet, when the size of the region grows, this discrete
    combinatorial problem gives rise to striking  phenomena: limit
    shapes, frozen and liquid phases, universal fluctuations, and connections to
    Gaussian free fields, integrable systems, random matrices, representation
    theory, and statistical mechanics.
  </Typography>

  <Typography className={classes.p}>
    A central theme of the course is the passage from exact combinatorial
    formulas to asymptotic analysis. Many random tiling models admit beautiful
    algebraic and combinatorial descriptions, often through determinants,
    non-intersecting paths, Schur processes, or dimer models. These structures
    then open the door to analytic methods such as orthogonal polynomials,
    Wiener–Hopf factorizations, Riemann–Hilbert and steepest descent techniques,
    and the study of limiting Gibbs measures. This interplay between discrete
    structure and continuous asymptotic behavior is one of the main sources of
    the richness of the subject.
  </Typography>

  <Typography className={classes.p}>
    The running example will be domino tilings of the Aztec diamond, one of the
    most classical and beautiful models in the field. Starting from its
    combinatorial foundations, the course will develop the analytic tools needed
    to understand large random tilings. Topics include Arctic circles and limit
    shapes, determinantal point processes, Schur processes and their extensions,
    orthogonal polynomials, doubly periodic weighted tilings, asymptotic analysis
    via steepest descent, limiting Gibbs measures, and Gaussian free field
    fluctuations. Along the way, we will discuss both classical results and more
    recent developments in this active area of research.
  </Typography>

  <Typography className={classes.p}>
    After completing the course, students should have a solid understanding of
    the main research questions in random tilings, the combinatorial structures
    behind the models, and the analytic techniques used to study their large
    scale behavior. The course aims to prepare students to engage with current
    research literature and to approach open problems in the field.
  </Typography>

  <Typography
    variant="h6"
    style={{ marginTop: 15, color: '#009688', fontStyle: 'italic' }}
  >
    Prerequisites
  </Typography>

  <Typography className={classes.p}>
    A good knowledge of probability and analysis is recommended. Familiarity
    with basic combinatorics and complex analysis will be helpful, especially
    for the more technical parts of the course.
  </Typography>
      <Typography
        variant="h6"
        style={{ marginTop: 15, color: '#009688', fontStyle: 'italic' }}
      >
        Overview of the lectures
      </Typography>

      <Typography className={classes.p}>
        January 15 (Thu), 14:00–17:15 
        <br />
        <strong>Lecture 1:</strong>
        <br />
        Introduction; discrete determinantal point processes
        <br />
    
      
        <br />
        <br />
        January 22 (Thu), 14:00–17:15  <br />
        <strong>Lecture 2:</strong>
        <br />
        Non-intersecting paths, LGV Theorem, Eynard-Mehta Theorem
        <br />
       
        <br />
        January 27 (Tue), 09:30–12:45  <br />
        <strong>Lecture 3:</strong>
        <br />
        Asymptotic study of the uniform Aztec diamond
        <br />
  
      
        <br />
        February 3 (Tue), 09:30–12:45 <br />
        <strong>Lecture 4:</strong>
        <br />
        Schur measure, partition functions, Borodin-Okounkov identity
        <br />
        
        <br />
        <strong>Lecture 5:</strong>
        <br />
        Doubly periodic tilings
        <br />
         February 17 (Tue), 09:30–12:45 <br />
        <br />
        <strong>Lecture 6:</strong>
        <br />
        Height fluctuations and the Gaussian free field
        <br />
        <br />
         March 3 (Tue), 09:30–12:45 <br />
        <br />
        <br />
        <strong>Lecture 7:</strong>
        <br />
        Orthogonal polynomials, Painlevé transcendents, and lozenge tilings of the
        hexagon
        <br />
         March 10 (Tue), 09:30–12:45 <br />
        <br />
      </Typography>

      <Typography
        variant="h6"
        style={{ marginTop: 15, color: '#009688', fontStyle: 'italic' }}
      >
        Literature
      </Typography>

      <Typography className={classes.p}>
        {/* Add references here */}
      </Typography>
    </Grid>
  </Grid>
</div>

  );
}


export default Contact